/**
 * Reducer for Call Management & UX feature.
 */
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CALL_WAITING_INCOMING, INCOMING_P2P_CALL, INCOMING_P2P_CLEAR, CALL_WAITING_RESPONDED, CALL_WAITING_DISMISS, HELD_CALL_CLEARED, HELD_CALL_SET, CALL_HOLD_UPDATED, CALL_ON_HOLD, CALL_OFF_HOLD, CONFERENCE_INVITE, CONFERENCE_ADD_RINGING, CONFERENCE_PARTICIPANT_REMOVED, CHAT_MESSAGE_RECEIVED, CHAT_MESSAGE_SENT, CHAT_HISTORY_LOADED, CHAT_PANEL_TOGGLE, PREFERENCES_UPDATED, DND_TOGGLED, DARK_MODE_CHANGED, P2P_TARGET_DND } from './actionTypes';
const DEFAULT_PREFERENCES = {
    dnd_enabled: false,
    dnd_message: null,
    dark_mode: 'system',
    camera_default_off: false,
    mic_default_off: true,
    skip_waiting_room: false,
    remember_media_permissions: true
};
const INITIAL_STATE = {
    incomingCall: null,
    callWaitingAction: null,
    incomingP2PCall: null,
    heldCall: null,
    onHold: false,
    holdCallId: null,
    heldBy: null,
    conferenceInvite: null,
    conferenceRinging: null,
    chatMessages: [],
    chatPanelOpen: false,
    currentChatCallId: null,
    preferences: { ...DEFAULT_PREFERENCES },
    targetDnd: null
};
ReducerRegistry.register('features/call-management', (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // Call Waiting
        case CALL_WAITING_INCOMING:
            return {
                ...state,
                incomingCall: action.data,
                callWaitingAction: null
            };
        case CALL_WAITING_RESPONDED:
            return {
                ...state,
                callWaitingAction: action.data.action,
                incomingCall: action.data.action === 'reject' ? null : state.incomingCall
            };
        case CALL_WAITING_DISMISS:
            return {
                ...state,
                incomingCall: null,
                callWaitingAction: null
            };
        case HELD_CALL_SET:
            return {
                ...state,
                heldCall: action.heldCall || null
            };
        case HELD_CALL_CLEARED:
            return !action.callId || state.heldCall?.callId === action.callId
                ? { ...state, heldCall: null }
                : state;
        // Incoming P2P call (not already on a call)
        case INCOMING_P2P_CALL:
            return {
                ...state,
                incomingP2PCall: action.data
            };
        case INCOMING_P2P_CLEAR:
            return {
                ...state,
                incomingP2PCall: null
            };
        // Call Hold
        case CALL_HOLD_UPDATED:
            return {
                ...state,
                onHold: action.data.onHold,
                holdCallId: action.data.callId
            };
        case CALL_ON_HOLD:
            return {
                ...state,
                onHold: true,
                holdCallId: action.data.callId,
                heldBy: action.data.heldBy
            };
        case CALL_OFF_HOLD:
            return {
                ...state,
                onHold: false,
                holdCallId: null,
                heldBy: null
            };
        // Conference
        case CONFERENCE_INVITE:
            return {
                ...state,
                conferenceInvite: action.data
            };
        case CONFERENCE_ADD_RINGING:
            return {
                ...state,
                conferenceRinging: action.data.targetClientId
            };
        case CONFERENCE_PARTICIPANT_REMOVED:
            return {
                ...state,
                conferenceRinging: null
            };
        // Chat
        case CHAT_MESSAGE_RECEIVED:
            return {
                ...state,
                chatMessages: [...state.chatMessages, action.data]
            };
        case CHAT_MESSAGE_SENT:
            return {
                ...state,
                chatMessages: [
                    ...state.chatMessages,
                    {
                        ...action.data,
                        senderId: 'self',
                        senderName: 'You',
                        timestamp: Date.now()
                    }
                ]
            };
        case CHAT_HISTORY_LOADED:
            return {
                ...state,
                chatMessages: action.data.messages,
                currentChatCallId: action.data.callId
            };
        case CHAT_PANEL_TOGGLE:
            return {
                ...state,
                chatPanelOpen: !state.chatPanelOpen
            };
        // Preferences
        case PREFERENCES_UPDATED:
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    ...action.data
                }
            };
        case DND_TOGGLED:
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    dnd_enabled: action.data.enabled,
                    dnd_message: action.data.message ?? state.preferences.dnd_message
                }
            };
        case DARK_MODE_CHANGED:
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    dark_mode: action.data.mode
                }
            };
        // P2P Target DND
        case P2P_TARGET_DND:
            return {
                ...state,
                targetDnd: action.data
            };
        default:
            return state;
    }
});
